import apiClient from './client';

export const projectsAPI = {
  getAll: async (filters = {}) => {
    // Trailing slash важен для FastAPI
    const params = new URLSearchParams(filters);
    const response = await apiClient.get(`/projects/?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/projects/${id}`);
    return response.data;
  },

  create: async (projectData) => {
    // Trailing slash важен для FastAPI - без него 307 redirect и потеря body
    const response = await apiClient.post('/projects/', projectData);
    return response.data;
  },

  update: async (id, updateData) => {
    const response = await apiClient.put(`/projects/${id}`, updateData);
    return response.data;
  },

  updateStage: async (projectId, stageType, stageData) => {
    const response = await apiClient.put(`/projects/${projectId}/stages/${stageType}`, stageData);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/projects/${id}`);
    return response.data;
  },

  // === Stage 11.4: Lifecycle Actions ===

  archive: async (id, reason = null) => {
    const response = await apiClient.post(`/projects/${id}/archive`, { reason });
    return response.data;
  },

  unarchive: async (id) => {
    const response = await apiClient.post(`/projects/${id}/unarchive`);
    return response.data;
  },

  close: async (id, reason = null) => {
    const response = await apiClient.post(`/projects/${id}/close`, { reason });
    return response.data;
  },

  reopen: async (id) => {
    const response = await apiClient.post(`/projects/${id}/reopen`);
    return response.data;
  },

  restore: async (id) => {
    const response = await apiClient.post(`/projects/${id}/restore`);
    return response.data;
  },
};
